import { cn } from '@/lib/utils';
import compactLogo from '@/assets/logo-targetnaai-compact.svg';
import mainLogo from '@/assets/logo-targetna-main-2.png';

interface BrandLogoProps {
  showTagline?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap: Record<NonNullable<BrandLogoProps['size']>, string> = {
  sm: 'h-24',
  md: 'h-32',
  lg: 'h-20',
};

export default function BrandLogo({ showTagline = false, size = 'md', className }: BrandLogoProps) {
  if (!showTagline) {
    return <img src={compactLogo} alt="Targetna AI logo" className={cn('w-auto', sizeMap[size], className)} />;
  }

  return (
    <img src={mainLogo} alt="Targetna AI - Hit your sales bullseye" className={cn('w-auto', sizeMap[size], className)} />
  );
}
